import { chain } from './chain';
import { setStyle } from './setStyle';
export const preventScrollStandard = () => chain(setStyle(document.body, 'paddingRight', `${window.innerWidth - document.body.clientWidth}px`), setStyle(document.body, 'overflow', 'hidden'));
//# sourceMappingURL=preventScrollStandard.js.map